"use strict";

exports.__esModule = true;
exports.fetchByGps = void 0;

var util_1 = require("../../util");

var validation_1 = require("./validation");
/**
 * Fetch the closest station to the user's current position.
 *
 * @param gps - Latitude and longitude of the user's current position
 */


function fetchByGps(gps) {
  var latitude = gps.latitude,
      longitude = gps.longitude;
  return util_1.fetchAndDecode("https://wind.waqi.info/mapq/nearest?geo=1/" + latitude + "/" + longitude, validation_1.ByStationCodec);
}

exports.fetchByGps = fetchByGps;